import React from "react";

import TermsList from "../../../recruiter/Activation/TermsList";

import SectionHeader from "./SectionHeader";

function TermsSection({ preferredLink }) {
  return (
    <>
      <SectionHeader title="Agency Terms Overview" />
      <TermsList preferredLink={preferredLink} />
    </>
  );
}

export default TermsSection;
